import React from "react";
import { Link } from "react-router-dom";
import { FaBullhorn, FaPaintBrush, FaDesktop, FaMobileAlt, FaCogs, FaShieldAlt } from "react-icons/fa";
import "./ServicesSection.css";

const Services = ({ isDarkMode }) => {
  const services = [
    { title: "Marketing", description: "Boost your brand and reach with our strategic marketing solutions.", icon: FaBullhorn, link: "marketing" },
    { title: "Graphic Design", description: "Creative designs to elevate your brand identity.", icon: FaPaintBrush, link: "graphic-design" },
    { title: "Web Design", description: "Modern, responsive websites tailored to your business needs.", icon: FaDesktop, link: "web-design" },
    { title: "App Development", description: "Custom mobile applications for both iOS and Android.", icon: FaMobileAlt, link: "app-development" },
    { title: "Software Development", description: "Scalable software solutions to drive your business forward.", icon: FaCogs, link: "software-development" },
    { title: "Cyber Security", description: "Protect your data with our advanced security solutions.", icon: FaShieldAlt, link: "cyber-security" }
  ];

  return (
    <section className={`services-section ${isDarkMode ? "dark" : "light"}`}>
      <h2>Our Services</h2>
      <div className="services-row">
        {services.map((service, index) => {
          const IconComponent = service.icon;
          return (
            <article key={index} className="service-card">
              <IconComponent className="service-icon" aria-label={service.title} />
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              {/* SEO-friendly navigation with anchor tags */}
              <Link to={`/services/${service.link}`} className="service-button" style={{ textDecoration: "none" }}>
  Learn More
</Link>
            </article>
          );
        })}
      </div>

      {/* JSON-LD for structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "AstraSight Technologies Services",
          "serviceType": "Technology and Software Services",
          "provider": {
            "@type": "Organization",
            "name": "AstraSight Technologies",
            "url": "https://astrasighttech.com"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Services",
            "itemListElement": services.map(service => ({
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": service.title,
                "description": service.description,
                "url": `https://astrasighttech.com/services/${service.link}`
              }
            }))
          }
        })}
      </script>
    </section>
  );
};

export default Services;
